import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackEvent, classifyClick } from "../lib/analytics";

const AnalyticsListener = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    const t = setTimeout(() => trackPageView(path), 150);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onClick = (e) => {
      const anchor = e.target.closest && e.target.closest("a[href]");
      if (!anchor) return;
      const ev = classifyClick(anchor);
      if (ev) trackEvent(ev.name, { ...ev.params, page_path: window.location.pathname });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
};

export default AnalyticsListener;
